/* eslint-disable react/require-default-props */
import React, { useRef } from 'react';
import { Button } from '../../atoms/Button/Button';
import { Text } from '../../atoms/Text/Text';
import { Modal } from '../Modal/Modal';
import { ModalHeader } from '../Modal/ModalHeader';
import { ModalBody } from '../Modal/ModalBody';
import { ModalFooter } from '../Modal/ModalFooter';
let confirmDialogIdCounter = 0;
function nextConfirmDialogId() {
    confirmDialogIdCounter += 1;
    return confirmDialogIdCounter;
}
/**
 * ConfirmDialog — accessible confirmation modal with primary/secondary action buttons.
 *
 * Built on the `Modal` molecule, using the shared `ModalHeader`, `ModalBody`, and
 * `ModalFooter` parts. Replaces the legacy Kendo-based `ConfirmDialog` component
 * at `frontend/components/ConfirmDialog/ConfirmDialog.jsx`.
 *
 * @example
 * <ConfirmDialog
 *   isOpen={isDeleting}
 *   title="Delete conversation?"
 *   description="This action cannot be undone."
 *   confirmLabel="Delete"
 *   confirmVariant="danger"
 *   onConfirm={handleDelete}
 *   onCancel={handleCancel}
 * />
 */
export function ConfirmDialog({ isOpen, title, description, onConfirm, onCancel, loading = false, confirmLabel = 'OK', cancelLabel = 'Cancel', confirmVariant = 'primary', cancelVariant = 'default', className = '' }) {
    const idRef = useRef(nextConfirmDialogId());
    const descriptionId = `qmb-ui-modal--confirm-desc-${idRef.current}`;
    return (React.createElement(Modal, { isOpen: isOpen, onClose: loading ? () => undefined : onCancel, dismissOnBackdropClick: !loading, variant: "confirm", ariaLabel: title, ariaDescribedBy: descriptionId, className: className },
        React.createElement(ModalHeader, { title: title, onClose: loading ? undefined : onCancel }),
        React.createElement(ModalBody, null,
            React.createElement("div", { id: descriptionId }, typeof description === 'string' ? React.createElement(Text, { variant: "body" }, description) : description)),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { variant: cancelVariant, onClick: onCancel, disabled: loading }, cancelLabel),
            React.createElement(Button, { variant: confirmVariant, onClick: onConfirm, disabled: loading }, confirmLabel))));
}
